export const startupPackinfo = [
    "Dashboard",
    // "Front desk forms",
    "Implement Supervision guidelines",
    "Form data back-up",
    "NSW license Search query tool",
    "Subscribe to Email Alerts",
    "Set Free Alerts",
    "Get regular updates"
];

export const businessPackInfo = [
    "Review of current operations",
    "Upgrade supervision guidelines",
    "Implement policies & procedures",
    "Review initial data input",
    "Unlimited helpdesk and email support",
    "6 monthly backend review by iComply",
    "Discounted online CPD for all currently employed staff."
]

export const corporatePackInfo = [
    "Review of current operations",
    "Upgrade supervision guidelines",
    "Implement policies & procedures",
    "Review initial data input",
    "Dedicated account manager",
    "Unlimited helpdesk and email support",
    "4 monthly backend review by iComply",
    "Discounted online CPD for all currently employed staff",
    "Free online CPD for “Licensee in charge”"
]